const state = {
  timeSharing: false,
  advertManage: false,
  btnPermissionFlag: false,
  autoRule: false
}

const mutations = {
  SET_TIMESHARING: (state, data) => {
    state.timeSharing = data
  },
  SET_ADVERTMANAGE: (state, data) => {
    state.advertManage = data
  },
  SET_BTNPERMISSIONFLAG: (state, data) => {
    state.btnPermissionFlag = data
  },
  SET_AUTORULE: (state, data) => {
    state.autoRule = data
  },
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
